import { render, staticRenderFns } from "./wordetaildialog.vue?vue&type=template&id=7d997dbb&scoped=true&"
import script from "./wordetaildialog.vue?vue&type=script&lang=js&"
export * from "./wordetaildialog.vue?vue&type=script&lang=js&"
import style0 from "./wordetaildialog.vue?vue&type=style&index=0&id=7d997dbb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d997dbb",
  null
  
)

export default component.exports